import { List, Create, Edit, View, Purchase } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/recipe",
        component: List,
        name: "recipe.fd.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/recipe/create",
        component: Create,
        name: "recipe.fd.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/recipe/purchase/:id",
        component: Purchase,
        name: "recipe.fd.purchase",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/recipe/:id/edit",
        component: Edit,
        name: "recipe.fd.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/recipe/:id/view",
        component: View,
        name: "recipe.fd.view",
        meta: {
            requiresAuth: true,
        },
    },
];
